import { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import Translations from './../../utils/Translations';
import { generateKey } from '../../utils/CommonUtils';
import './../../../../src/VX/Asset/Less/VX/View/ActorMap.less';

const options = {
	iconAnchorOffset: [16, 21],
	iconSize: [36, 48],
	popupAnchorOffset: [0, 0],
};

class MarkerList extends Component {
	static toMarker(objects) {
		console.log(objects);
		return objects.map(function (obj) {
			switch (obj.type) {
				case 'ImageMarker': {
					const innerHtml =
						'<div class="actormap__actorcircle' +
						(obj.actorOnline ? ' is-online' : '') +
						'" style="background-image: url(' +
						obj.imagePath +
						'); background-position: center center; background-size: cover;"></div>';

					// react prop type error is wrong because divIcon extends Icon
					const icon = Leaflet.divIcon({
						className: 'mapMarker marker-small',
						html: innerHtml,
						iconAnchor: options.iconAnchorOffset,
						iconSize: options.iconSize,
						popupAnchor: options.popupAnchorOffset,
					});

					return (
						<Marker icon={icon} position={obj.position} key={generateKey(obj.actorId)}>
							{obj.noPopup !== true && (
								<Popup
									className="imagePopup"
									closeButton={false}
									offset={new Leaflet.Point([100, 100])}
									autoPanPaddingTopLeft={[20, 0]} // [left / top]
									// autoPanPaddingBottomRight={[150, 110]}
								>
									<div>
										<div className="leaflet__popupImage" style={{ backgroundImage: "url('" + obj.imagePath + "')" }}>
											<a className="btn-goto-profile leaflet__imageLink" href={obj.actorProfileLink} />
										</div>
										<div className="leaflet__popupTitle">
											<div className={'leaflet__text -status ' + (obj.actorOnline ? 'is-online' : 'is-offline')} />
											<div className="leaflet__text -name" title={obj.actorName}>
												{obj.actorName}
											</div>
											<div className="leaflet__text -age">({obj.actorAge})</div>
										</div>
										<a className="btn-goto-profile" href={obj.actorProfileLink}>
											<span>{Translations.get('ProSearchMapVisitProfile')}</span>
										</a>
									</div>
								</Popup>
							)}
						</Marker>
					);
				}
				case 'TextMarker': {
					const innerHtml = '<span class="textMarker__text">' + obj.text + '</span>';

					const icon = Leaflet.divIcon({
						className: 'h-color-text-dark -font-bold h-text-uppercase',
						html: innerHtml,
						iconAnchor: [141, 40],
						iconSize: [200, 30],
					});

					return <Marker position={obj.position} icon={icon} key={obj.actorId + '_text'} />;
				}
				case 'GuestMarker': {
					const icon = Leaflet.divIcon({
						className: 'guest-marker icon -icon-geolocation-full h-color-is-failure',
						html: '',
						iconAnchor: [20, 40],
						iconSize: [40, 40],
					});

					return <Marker position={obj.position} icon={icon} key="guestMarker" />;
				}
				// No default
			}

			return obj;
		});
	}

	constructor(props) {
		super(props);
		this.markerList = this.props.avoidDuplicates ? this.avoidDuplicates(this.props.markers) : this.props.markers;

		this.avoidDuplicates = this.avoidDuplicates.bind(this);
	}

	componentDidUpdate() {
		this.markerList = [];
		if (this.props && this.props.markers) {
			if (this.props.avoidDuplicates) {
				this.markerList = this.avoidDuplicates(this.props.markers);
			} else {
				this.markerList = this.props.markers;
			}
		}
	}

	avoidDuplicates(objects) {
		let diff = 0.05;
		if (this.props.zoom >= 13) {
			diff = 0.02;
		} else if (this.props.zoom >= 11) {
			diff = 0.03;
		} else if (this.props.zoom >= 9) {
			diff = 0.04;
		}

		const getRandomValue = function (uniqueId) {
			// get a seeded pseudo random number
			const x = Math.sin(uniqueId) * 100000;
			const rand = x - Math.floor(x);
			return rand * (diff + diff) - diff;
		};
		const knownPositions = {};

		objects.map((obj) => {
			if (typeof knownPositions[obj.position[0] + '|' + obj.position[1]] !== 'undefined') {
				obj.position[0] += getRandomValue(obj.actorId + obj.position[0]);
				obj.position[1] += getRandomValue(obj.actorId + obj.position[1]);
			}
			knownPositions[obj.position[0] + '|' + obj.position[1]] = 1;
		});

		return objects;
	}

	render() {
		const markerComponents = MarkerList.toMarker(this.markerList);
		return <div>{markerComponents}</div>;
	}
}

MarkerList.propTypes = {
	markers: PropTypes.array.isRequired,
	avoidDuplicates: PropTypes.bool.isRequired,
	zoom: PropTypes.number.isRequired,
};

export default MarkerList;
